export const BANNER_HEIGHT = 58;
